/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="14"
        viewBox="0 0 19 14"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m12.63.28-1.8 1.52H7.6L6.34 0H0v14h19V1.8h-5.2Zm-.15 1.44 2.14 2.78H9.19ZM1 1h4.82l1.25 1.8h2.57l-2 1.7H1.02Zm17 12H1V5.5h17Zm0-10.2v1.7h-2.12l-1.31-1.7Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FolderWithFileIcon';

export default Icon;
